export const onCreateCandidateBatch = /* GraphQL */ `
  subscription OnCreateCandidateBatch(
    $filter: ModelSubscriptionCandidateBatchFilterInput
  ) {
    onCreateCandidateBatch(filter: $filter) {
      id
      cvS3Keys
      csvS3Key
      jobDescription
      status
      campaignId
      candidatesCount
      candidatesRequirementsMetCount
      candidatesRequirementsNotMetCount
      candidatesToProcessCount
      organizationId
      userId
      createdAt
      atsJobId
      isRecalculatingScores
      candidateBatchGroupId
      isInitial
      candidateBatchReanalysisReferenceId
      title
      jobDescriptionParsed {
        jobTitle
        employerName
        location
        contractType
        hours
        salary
        closingDate
        summaryOfRole
        responsibilities
        qualifications
        benefits
        diversityEqualityInclusion
      }
    }
  }
`;

export const onUpdateCandidateBatch = /* GraphQL */ `
  subscription OnUpdateCandidateBatch(
    $filter: ModelSubscriptionCandidateBatchFilterInput
  ) {
    onUpdateCandidateBatch(filter: $filter) {
      id
      cvS3Keys
      csvS3Key
      jobDescription
      status
      candidatesCount
      candidatesToProcessCount
      organizationId
      userId
      createdAt
      updatedAt
      weights {
        relevantExperience
        relevantQualifications
        relevantSkills
        softSkills
      }
      title
      jobDescriptionParsed {
        jobTitle
        employerName
        location
        contractType
        hours
        salary
        closingDate
        summaryOfRole
        responsibilities
        qualifications
        benefits
        diversityEqualityInclusion
      }
    }
  }
`;

export const onCreateCandidate = /* GraphQL */ `
  subscription OnCreateCandidate(
    $filter: ModelSubscriptionCandidateFilterInput
  ) {
    onCreateCandidate(filter: $filter) {
      id
      totalScore
      scoring {
        category
        score
        description
      }
      firstName
      lastName
      email
      candidateBatchId
      createdAt
      updatedAt
      cvS3Key
      linkedInProfileId
      conversationId
      isMessagesGenerating
    }
  }
`;

export const onUpdateCandidate = /* GraphQL */ `
  subscription OnUpdateCandidate(
    $filter: ModelSubscriptionCandidateFilterInput
  ) {
    onUpdateCandidate(filter: $filter) {
      id
      isLocked
      firstName
      lastName
      email
      phoneNumber
      cvS3Key
      linkedInProfileId
      totalScore
      totalScoreScaled
      analysisErrorCode
      scoring {
        category
        weight
        score
        scoreScaled
        description
      }
      candidateBatchId
      conversationId
      createdAt
      isMessagesGenerating
      updatedAt
      organizationId
      status
    }
  }
`;
